module.exports = __webpack_public_path__ + "img/insurita-half-circle.e00be74b.svg";